import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colors from '~/utils/colors';

const StarContainer = styled.span`
  display: inline-block;
  position: relative;
  font-size: 20px;
`;

const Star = styled.span`
  color: ${Colors.yellow};
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 2;
`;

const StarEmpty = styled.span`
  color: ${Colors.lineGray};
  z-index: 1;
`;

const RatingPoint = (props) => {
  return (
    <StarContainer>
      <Star style={{width: `${(props.point / 5) * 100}%`}}>
        <span>★★★★★</span>
      </Star>
      <StarEmpty>
        <span>★★★★★</span>
      </StarEmpty>
    </StarContainer>
  );
};

RatingPoint.propTypes = {
  point: PropTypes.number,
};
RatingPoint.defaultProps = {
  point: 0,
};

export default RatingPoint;
